import { createClient } from '@supabase/supabase-js';
import { auth } from './firebaseConfig';

const supabaseUrl = 'https://ucbwfwdfrzntatcgmngv.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVjYndmd2RmcnpudGF0Y2dtbmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgyNzYyNzgsImV4cCI6MjA2Mzg1MjI3OH0.WXexVfxRqIsNfGatyqFBqF02u2PVYmKeEKdFx0NKf1w';

// Preparação para RLS com Firebase Authentication.
// IMPORTANTE: manter false até configurar a integração Firebase JWT no Supabase.
// Enquanto false, as consultas continuam com a role anon.
// ATENÇÃO: esta alteração NÃO protege tabelas sem RLS.
const USAR_TOKEN_FIREBASE_NO_SUPABASE = true;

const opcoesAutenticacao = USAR_TOKEN_FIREBASE_NO_SUPABASE
  ? {
      accessToken: async () => {
        const utilizador = auth.currentUser;
        if (!utilizador) return null;
        // O SDK Firebase renova automaticamente o ID token quando necessário.
        return utilizador.getIdToken();
      },
    }
  : {};

// Uma única instância partilhada por todos os hooks e componentes.
const supabase = createClient(supabaseUrl, supabaseKey, {
  ...opcoesAutenticacao,
  auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false },
});

export default supabase;
